export const dateConversion = (value: any) => {
  const apiDate = new Date(value);
  const year = apiDate.getFullYear();
  const month = String(apiDate.getMonth() + 1).padStart(2, "0");
  const day = String(apiDate.getDate()).padStart(2, "0");

  const formattedDate = `${year}-${month}-${day}`;
  return formattedDate;
};
